import api from "./api";

export type RechargeCreditsResponse = {
  message?: string;
  data?: {
    credit_balance?: number | string | null;
    company?: {
      credit_balance?: number | string | null;
    };
  };
};

function pickData<T extends Record<string, unknown>>(res: unknown): T | null {
  if (!res || typeof res !== "object") return null;
  const o = res as Record<string, unknown>;
  const d = o.data;
  if (d && typeof d === "object" && !Array.isArray(d)) return d as T;
  return null;
}

/**
 * Backend creates a Stripe PaymentIntent for this amount (GBP).
 * FE confirms payment with Stripe.js, then calls completeMarketingCreditsPurchase.
 */
export async function createMarketingCreditsPaymentIntent(payload: {
  amount: number;
  connect_account_id?: string;
}): Promise<{ client_secret: string }> {
  const response = await api.post("/admin/marketing/credits/create-payment-intent", payload);
  const data = pickData<{ client_secret?: string; clientSecret?: string }>(response.data) ??
    (response.data as { client_secret?: string; clientSecret?: string });
  const client_secret = data?.client_secret ?? data?.clientSecret;
  if (!client_secret) throw new Error("Invalid payment intent response");
  return { client_secret };
}

/**
 * After confirmCardPayment succeeds on the client, backend verifies the PaymentIntent
 * and increments company credit_balance in the DB.
 */
export async function completeMarketingCreditsPurchase(payload: {
  payment_intent_id: string;
  /** Laravel: PaymentIntent::retrieve($id, ['stripe_account' => $this]) when PI was created on Connect */
  connect_account_id?: string;
}) {
  const response = await api.post<RechargeCreditsResponse>(
    "/admin/marketing/credits/complete",
    payload,
  );
  return response.data;
}
